module.exports = __webpack_public_path__ + "img/logo-abalon-en.82781c7.png";